import React, { useState } from 'react';
import { Button, Col, Descriptions, List, Modal, Row, Typography } from 'antd';
import { useLocation } from 'react-router-dom';

const MemberVehicle = () => {
    const location = useLocation();
    const member = location.state.member;
    const vehicle = member.vehicles;

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedVehicle, setSelectedVehicle] = useState([]);

    const showModal = (item) => {
        const items = [
            {
                label: 'Model Name',
                value: item.model,
            },
            {
                label: 'Registration Number',
                value: item.reg_no,
            },
            {
                label: 'Vehicle Type',
                value: item.vehicle_class_desc,
            },
            {
                label: 'Manufacturing Year',
                value: item.manufacturing_yr,
            },
        ];
        setSelectedVehicle(items);
        setIsModalOpen(true);
    };

    return (
        <div className="layout-content">
            <Row justify={'center'}>
                <Col xs={12}>
                    <List
                        header={<Typography.Title level={4}>{member.name}'s Vehicles</Typography.Title>}
                        bordered
                        dataSource={vehicle}
                        renderItem={(item) => (
                            <List.Item
                                actions={[
                                    <Button
                                        type="primary"
                                        className="form-btn"
                                        onClick={() => showModal(item)}
                                    >
                                        View Vehicle
                                    </Button>,
                                ]}
                            >
                                <List.Item.Meta
                                    title={item.model}
                                    description={item.reg_no}
                                />
                            </List.Item>
                        )}
                    />
                </Col>
                <Modal
                    title="Vehicle Info"
                    open={isModalOpen}
                    onCancel={() => setIsModalOpen(false)}
                    footer={null}
                >
                    <Descriptions layout='vertical'>
                        {selectedVehicle.map((detail, index) => (
                            <Descriptions.Item key={index} label={detail.label} span={2}>
                                {detail.value}
                            </Descriptions.Item>
                        ))}
                    </Descriptions>
                </Modal>
            </Row>
        </div>
    );
};

export default MemberVehicle;
